/** Modos dos Pedidos */
export interface ConfigPedidoModo {
    id: number;
    nome: string;
}

export const modoPadrao: ConfigPedidoModo = {id: 1, nome: 'Padrão'};
export const modoTabelaPreco: ConfigPedidoModo = {id: 2, nome: 'Tabela de Preço'};

export const modosPedido: ConfigPedidoModo[] = [
    modoPadrao,
    modoTabelaPreco
];

/** Verifica se o é Padrão */
export function isModoPadrao(modo: number): boolean {
    if (!modo) {
        return false;
    }
    return modo === modoPadrao.id;
}

/** Verifica se o é Tabela de Preço */
export function isModoTabelaPreco(modo: number): boolean {
    if (!modo) {
        return false;
    }
    return modo === modoTabelaPreco.id;
}
